import { useMemo } from "react"

import useScreenSize from "./use-screen-size"
import useTouchPrimary from "./use-touch-primary"

export const TAILWIND_SIZE_XSMALL = "xs"
export const TAILWIND_SIZE_SMALL = "sm"
export const TAILWIND_SIZE_MEDIUM = "md"
export const TAILWIND_SIZE_LARGE = "lg"
export const TAILWIND_SIZE_XLARGE = "xl"
export const TAILWIND_SIZE_XXLARGE = "2xl"

export type ResponsiveMode = "mobile" | "tablet" | "desktop"

export const useResponsive = () => {
  const { width, height } = useScreenSize()
  const isTouchPrimary = useTouchPrimary()

  const tailwindSize = useMemo(() => {
    if (width >= 1536) {
      return TAILWIND_SIZE_XXLARGE
    }
    if (width >= 1280) {
      return TAILWIND_SIZE_XLARGE
    }
    if (width >= 1000) {
      return TAILWIND_SIZE_LARGE
    }
    if (width >= 768) {
      return TAILWIND_SIZE_MEDIUM
    }
    if (width >= 640) {
      return TAILWIND_SIZE_SMALL
    }
    return TAILWIND_SIZE_XSMALL
  }, [width])

  const isMobile = tailwindSize === TAILWIND_SIZE_XSMALL
  const isTablet = tailwindSize === TAILWIND_SIZE_SMALL || tailwindSize === TAILWIND_SIZE_MEDIUM
  const isDesktop = !isMobile && !isTablet
  const preferMobileNav = isMobile || isTouchPrimary

  const isPortrait = window.innerHeight > window.innerWidth
  const isLandscape = !isPortrait

  return {
    tailwindSize,
    isMobile,
    isTablet,
    isDesktop,
    isTouchPrimary,
    preferMobileNav,
    width,
    height,
    isPortrait,
    isLandscape,
  }
}

export default useResponsive
